import ReactDOM from 'react-dom/client'
import { Amplify } from '@aws-amplify/core'
import { RestAPI as AmplifyAPI } from '@aws-amplify/api-rest'
import { lazy, Suspense } from 'react'
import './global.css'
import 'normalize.css'
import 'antd/dist/reset.css'
const App = lazy(() => import('./App'))
import initReportingObserver from './shared/utils/initReportingObserver'
import { ConfigProvider } from 'antd'
import { theme } from './themeConfig'
import { amplifyConfig } from './amplifyConfig'
import store from './store/store'
import { Provider } from 'react-redux'
import awsConfig from './shared/utils/awsConfig'

const env = awsConfig?.roleEnv // if is missing then add in index.html as <script>window._env_ = { roleEnv: 'your-env' }</script>
const isLocal = awsConfig?.environment === 'local'
const disableLog = !isLocal && env !== 'local' && env !== 'dev'

// console.error is intentionally left intact for real errors / error-tracking tools
// but React routes dev-mode warnings through console.error with a "Warning:" prefix,
// so filter those out while preserving real errors.
const nativeConsoleError = console.error.bind(console)
console.error = (...args: unknown[]) => {
  const first = args[0]
  if (disableLog && typeof first === 'string' && first.startsWith('Warning:')) {
    return
  }
  nativeConsoleError(...args)
}

if (disableLog) {
  console.log = () => {}
  console.info = () => {}
  console.debug = () => {}
  console.warn = () => {}
}

initReportingObserver()
Amplify.configure(amplifyConfig)
AmplifyAPI.configure(amplifyConfig)

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
  <Suspense fallback={<div>Loading...</div>}>
    <Provider store={store}>
      <ConfigProvider theme={theme}>
        <App />
      </ConfigProvider>
    </Provider>
  </Suspense>,
)
